import React, { useState, useCallback, useEffect } from 'react';

import { useDictionary, usePage } from '@/src/app/hooks';
import {
    Loading,
    ErrorMessage,
    ResourceBoxInner,
    Container,
    type ResourceHeaderDTO,
} from '@/src/ui';
import { apiRequest } from '@/src/services';
import './UserGuidesPage.css';

const UserGuidesPage: React.FC = () => {
    const { translate } = useDictionary();
    const { setSubheaderTitle, setSubheaderType, pageLanguage } = usePage();
    document.title = translate('User Guides', 'User Guides');

    const [userGuidesData, setUserGuidesData] = useState<ResourceHeaderDTO[] | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        setSubheaderTitle(translate('User Guides'));
        setSubheaderType('default');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [translate]);

    useEffect(() => {
        (async function fetchData() {
            setError('');
            setLoading(true);
            setUserGuidesData(null);
            try {
                const res = await apiRequest<ResourceHeaderDTO[]>('GET', `dbo/userGuides`);
                setUserGuidesData(res.data);
            } catch {
                setError('Failed to fetch data');
            } finally {
                setLoading(false);
            }
        })();
    }, [pageLanguage]);

    const renderColumn = useCallback(
        (colNo: number) => {
            return null;
            const boxes = userGuidesData?.filter((box) => box.columnNumber === colNo) || [];
            return (
                <>
                    {boxes.map((box) => (
                        <div id={box.id} className={`user-guides-box background pd-primary`}>
                            <div className="tile-headings">{box.title}</div>
                            {box.items.map((item) => {
                                const anchorId = `user-guides-container-c${colNo}-${item.id}`;
                                return (
                                    <ResourceBoxInner
                                        key={anchorId}
                                        id={anchorId}
                                        item={item}
                                        namespace="user-guides"
                                    />
                                );
                            })}
                        </div>
                    ))}
                </>
            );
        },
        [userGuidesData]
    );

    return (
        <Container>
            <ErrorMessage error={error} />
            {loading ? (
                <Loading />
            ) : (
                <div className="user-guides-container">
                    {/* <div className="row gx-5 justify-content-center" id="dashboard">
                        <div id="column_1" className="col-4 user-guides-column">
                            {renderColumn(1)}
                        </div>
                        <div id="column_2" className="col-4 user-guides-column">
                            {renderColumn(2)}
                        </div>
                    </div> */}
                    {/* For warnings: */}
                    {renderColumn(0)}
                    <h2>Coming soon!</h2>
                </div>
            )}
            <div>Tech support:</div>
            <a href="mailto:support@paradigmmath.com">support@paradigmmath.com</a>
        </Container>
    );
};

export default UserGuidesPage;
